import i18n from '@/plugins/i18n';
export const forms = [
    {
        type: 'select',
        name: 'ADFilter',
        nextField: 'ADUser',
        title: i18n.t('user.form.ADFilter'),
        rules: {required: true},
        modal: ['filter'],
        data: ['filter'],
        options: {
            data: [],
            label: 'description',
            track: 'id'
        },
        additionalButton: {
            icon: 'plus',
            variant: 'primary',
            size: 'sm',
            title: i18n.t('general.add'),
            type: 'User',
        },
        checkBox: false
    },
    {
        type: 'grid',
        beforeField: 'ADFilter',
        name: 'ADUser',
        title: i18n.t('user.form.ADUser'),
        rules: {},
        modal: ['username'],
        data: ['sAMAccountName'],
    },
    {
        type: 'select',
        name: 'authGrp',
        connectField: 'ADUser',
        title: i18n.t('user.form.authGroup'),
        rules: {required: true},
        modal: ['auth_code'],
        data: ['authority_info'],
        options: {
            data: [],
            label: 'authority_name',
            track: 'authority_code'
        },
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'select',
        name: 'userType',
        connectField: 'ADUser',
        title: i18n.t('user.form.userType'),
        rules: {required: true},
        options: {
            data: [],
            label: 'name',
            track: 'id'
        },
        modal: ['user_type'],
        data: ['user_type'],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'select',
        name: 'customer',
        connectField: 'userType',
        connectFieldKey: ['key'],
        connectFieldValue: ['CST'],
        title: i18n.t('user.form.customer'),
        rules: {required: true},
        modal: ['customer_info', 'id'],
        data: ['customer_info'],
        options: {
            data: [],
            label: 'name',
            track: 'ID'
        },
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'select',
        name: 'company',
        connectField: 'userType',
        connectFieldKey: ['key'],
        connectFieldValue: ['CMP'],
        title: i18n.t('user.form.firm'),
        rules: {required: true},
        modal: ['company_info', 'id'],
        data: ['company_info'],
        options: {
            data: [],
            label: 'name',
            track: 'id'
        },
        additionalButton: false,
        checkBox: false
    },
   
]
export default forms;


// WEBPACK FOOTER //
// ./src/pages/General/Users/forms/ADUserForm.js